// Mock data for Siesta Key Gulf Front Escape
// EASY IMAGE SWAPPING: Simply replace the URLs below with your actual property photos

import bookedDates from './bookedDates.json';

const p = process.env.PUBLIC_URL || '';

export const propertyData = {
  name: "Siesta Key Gulf Front Escape",
  tagline: "Beach Rental • Unit G-201 • Excelsior Condominiums, Sarasota, Florida",
  description: "Experience the best of Florida's Gulf Coast at our beautifully appointed 2-bedroom, 2-bath condo in the desirable Excelsior Beach to Bay complex. Enjoy direct Gulf-front views and spectacular sunsets from your private balcony, just steps away from the world-famous, soft white sands of Siesta Key Beach.",
  
  address: {
    street: "6264 Midnight Pass Road",
    city: "Siesta Key",
    state: "FL",
    zip: "34242",
    unit: "G-201"
  },

  contact: {
    email: "teri.excelsior201g@gmail.com",
    phone: "215-768-4589"
  },

  amenities: {
    condoHighlights: [
      "Spacious master suite with king-size bed, ample storage, large closet, TV, and an en-suite bath featuring dual vanities",
      "Second bedroom with two queen-size beds, dresser, closet, TV, and easy access to a second full bath",
      "Bedrooms are separated for maximum privacy",
      "In-unit washer and dryer for your convenience",
      "Free wireless internet",
      "One dedicated, covered parking spot plus overflow parking for a second vehicle"
    ],
    fullyEquipped: [
      "Fully stocked kitchen with everything you'll need to prepare meals",
      "Open-plan dining and living areas provide plenty of space to relax",
      "Private balcony with stunning Gulf-front views"
    ],
    resortAmenities: [
      "Private beach with complimentary loungers and chairs",
      "Two large heated swimming pools and two hot tubs",
      "Shuffleboard courts",
      "Two lighted tennis courts and two lighted pickleball courts",
      "Fitness center",
      "Outdoor BBQ/picnic areas",
      "Community room and library",
      "Intercoastal fishing pier and shaded viewing area",
      "Poolside restrooms for added convenience"
    ],
    location: [
      "Walking distance to restaurants, bars, shops, grocery and convenience stores",
      "Bike and boat rentals available in the vibrant South Village",
      "Free trolley service to Siesta Key Village for dining, shopping, and nightlife"
    ]
  },

  rentalRates: [
    { periodStart: "Oct 1, 2026", periodEnd: "Nov 20, 2026", dailyRate: "$326", weeklyRate: "$2,282" },
    { periodStart: "Nov 21, 2026", periodEnd: "Dec 5, 2026", dailyRate: "$510", weeklyRate: "$3,570" },
    { periodStart: "Dec 6, 2026", periodEnd: "Dec 18, 2026", dailyRate: "$495", weeklyRate: "$3,465" },
    { periodStart: "Dec 19, 2026", periodEnd: "Jan 2, 2027", dailyRate: "$510", weeklyRate: "$3,570" },
    { periodStart: "Jan 3, 2027", periodEnd: "Mar 19, 2027", dailyRate: "$495", weeklyRate: "$3,465" },
    { periodStart: "Mar 20, 2027", periodEnd: "Apr 3, 2027", dailyRate: "$510", weeklyRate: "$3,570" },
    { periodStart: "Apr 4, 2027", periodEnd: "Apr 30, 2027", dailyRate: "$495", weeklyRate: "$3,465" },
    { periodStart: "May 1, 2027", periodEnd: "Jun 26, 2027", dailyRate: "$326", weeklyRate: "$2,282" },
    { periodStart: "Jun 27, 2027", periodEnd: "Jul 10, 2027", dailyRate: "$510", weeklyRate: "$3,570" },
    { periodStart: "Jul 11, 2027", periodEnd: "Nov 19, 2027", dailyRate: "$326", weeklyRate: "$2,282" },
    { periodStart: "Nov 20, 2027", periodEnd: "Nov 27, 2027", dailyRate: "$510", weeklyRate: "$3,570" },
    { periodStart: "Nov 28, 2027", periodEnd: "Dec 17, 2027", dailyRate: "$495", weeklyRate: "$3,465" },
    { periodStart: "Dec 18, 2027", periodEnd: "Jan 2, 2028", dailyRate: "$510", weeklyRate: "$3,570" }
  ],

  additionalFees: {
    securityDeposit: "$1,000",
    processingFee: "$150",
    touristTax: "13%",
    cleaningFee: "$190"
  },

  rentalInfo: {
    minimumStay: [
      "1-week minimum stay is required May 1st – Oct 31st",
      "2-week minimum stay is required Nov 1st – April 30th",
      "*No set check-in days*"
    ],
    oddDays: "Odd days are pro-rated at the daily rate",
    uponBooking: "25% of total rental fee plus the $150 processing fee and executed rental agreement are required to secure the reservation",
    balanceDue: "Remaining rent, all applicable taxes, cleaning fee ($190), and security deposit ($1,000) must be paid in full 90 days prior to arrival",
    restrictions: "No pets and no smoking allowed"
  },

  cancellationPolicy: [
    {
      title: "Lessor Cancellation",
      description: "Should the Lessor cancel the booking at any time prior to the scheduled check-in, for any reason and through no fault of the Guest, the Guest shall receive a full refund of all amounts paid."
    },
    {
      title: "More Than 90 Days Prior to Arrival",
      description: "The deposit shall be refunded in full, less the $150 rental agreement processing fee required by Excelsior Real Estate Corp."
    },
    {
      title: "Less Than 90 Days Prior to Arrival",
      description: "No refund shall be issued unless the unit is subsequently re-rented for the same period."
    },
    {
      title: "Early Departure",
      description: "No refunds will be issued for early departure."
    }
  ],

  testimonials: [
    {
      name: "Bill G.",
      text: "Siesta Key Gulf Front Escape truly is our Happy Place! The condo offers stunning sunset views from the balcony, overlooking the pool and hot tub area below. It's the perfect spot to relax with a drink in hand as the sun dips into the Gulf. The property is beautifully maintained, with a heated pool just steps from the powdery white sands of Siesta Key Beach. Inside, the condo is spotless, tastefully furnished, and fully equipped with all the comforts of home. You can tell the owners care about their guests—their communication is quick, kind, and welcoming. We also love the extra amenities this property offers, like the exercise room and pickleball courts, which make it easy to stay active between beach days. Every visit reminds us why we keep coming back—Siesta Key Gulf Front Escape is the perfect blend of comfort, relaxation, and beachside paradise.",
      rating: 5
    },
    {
      name: "Tina H.",
      text: "This place is truly paradise. The condo is beautifully decorated and the accommodations are excellent. Everything you need for a relaxing beach vacation is there waiting for you. The condo is well equipped if you choose to stay in for meals and just a short trolly ride into the village for additional dining options. There are also places within walking distance. The owner is easily accessible and responds quickly to questions and concerns. We absolutely love this condo and plan to return year after year!",
      rating: 5
    },
    {
      name: "Jennifer S.",
      text: "Wonderful condo, awesome views, easy access to everything, warm pool, hot tub is nice and hot, owners are very attentive. The beach is FABULOUS! You will not regret renting this condo and will want to book again. My family and I have been guests at this condo for 3 Christmas vacations and 1 spring break and we look forward to each visit.",
      rating: 5
    },
    {
      name: "Cindy L.",
      text: "Beautiful condo in a great town. The sunsets off the balcony are absolutely beautiful. I love the powder white beaches. The condo is well stocked, well maintained and has plenty of space. The complex has many amenities-pool and hot tub right down the steps and pickleball right across the street. I also love the location, you can walk down to several restaurants and shops or hop the trolley for a quick ride down to the Village. The owners are welcoming and friendly and respond quickly to any questions or concerns. We have been staying here for several years and can't wait for our next trip.",
      rating: 5
    },
    {
      name: "Angie B.",
      text: "Location, location, location! This wonderful condominium is steps away from the soft, white sand of Siesta Key beach, making it the absolute perfect spot for a getaway. The condo is roomy, comfortable, and incredibly well-equipped with everything you could possibly want or need. We loved watching the amazing sunsets—the views are spectacular whether you're sitting in a beach chair or relaxing on the balcony. The kitchen is fully equipped and perfect for cooking meals at home, but the local restaurant scene is also just minutes away and easily accessible. We had a flawless stay and cannot recommend this rental enough!",
      rating: 5
    },
    {
      name: "Kylie",
      text: "One of my absolute favorite places I've ever visited! It features a breathtaking view and serves as the ultimate spot to watch the sunset. It also offers effortless access to a beautiful beach, complete with complimentary beach chairs. Plus, it is just a short, easy walk to fantastic local shops, coffee, dining, and ice cream. I highly recommend this destination and cannot wait to return!",
      rating: 5
    },
    {
      name: "Sinclair & Matthew W.",
      text: "We absolutely loved staying in this condo! The location couldn't get any better, the amenities are wonderful and very well up kept! The condo was beautifully updated and extremely clean, all linens were comfortable, and the kitchen was well stocked. The view of the gulf was perfect. We will absolutely rent this condo again and could not recommend more!",
      rating: 5
    }
  ],

  // PLACEHOLDER IMAGES - Replace these URLs with your actual property photos
  // Organized by category for easy management
  // Drop your photos into frontend/public/images/<category>/ and update the paths below
  images: {
    hero: `${p}/images/outside/hero.jpg`,

    outsideViews: [
      `${p}/images/outside/outside-1.jpg`,
      `${p}/images/outside/outside-2.jpg`,
      `${p}/images/outside/outside-3.jpg`,
      `${p}/images/outside/outside-4.jpg`,
      `${p}/images/outside/outside-5.jpg`,
      `${p}/images/outside/outside-6.jpg`,
      `${p}/images/outside/outside-7.jpg`,
      `${p}/images/outside/outside-8.jpg`,
      `${p}/images/outside/outside-9.jpg`,
      `${p}/images/outside/outside-10.jpg`,
    ],

    bedrooms: [
      `${p}/images/bedrooms/bedroom-1.jpg`,
      `${p}/images/bedrooms/bedroom-2.jpg`,
      `${p}/images/bedrooms/bedroom-3.jpg`,
      `${p}/images/bedrooms/bedroom-4.jpg`,
      `${p}/images/bedrooms/bedroom-5.jpg`,
      `${p}/images/bedrooms/bedroom-6.jpg`,
      `${p}/images/bedrooms/bedroom-7.jpg`,
      `${p}/images/bedrooms/bedroom-8.jpg`,
    ],

    kitchen: [
      `${p}/images/kitchen/kitchen-1.jpg`,
      `${p}/images/kitchen/kitchen-2.jpg`,
      `${p}/images/kitchen/kitchen-3.jpg`,
    ],

    livingRoom: [
      `${p}/images/living-room/living-room-1.jpg`,
      `${p}/images/living-room/living-room-2.jpg`,
      `${p}/images/living-room/living-room-3.jpg`,
    ],

    guestBedroom: [
      `${p}/images/guest-bedroom/guest-bedroom-1.jpg`,
      `${p}/images/guest-bedroom/guest-bedroom-2.jpg`,
      `${p}/images/guest-bedroom/guest-bedroom-3.jpg`,
    ]
  },

  // Synced from Google Calendar by scripts/sync-bookings.mjs — see bookedDates.json
  bookedDates
};
